import { Routes } from '@angular/router';
import { ArchivierteDatenabfrageListComponent } from './archivierte-datenabfrage-list/archivierte-datenabfrage-list.component';
import { DatenabfragePageComponent } from './datenabfrage-page/datenabfrage-page.component';

export const datenabfrageRoutes: Routes = [

    {   // lists all available Datenabfragen for a Westnetz-User
        path: 'datenabfrage-page',
        component: DatenabfragePageComponent,
    },

    {   // lists all available Datenabfragen for a Westnetz-User
        path: 'list-datenabfragen',
        component: ArchivierteDatenabfrageListComponent,
    },
];
